(function (global) {
  const editorParamNames = [
    "_ab",
    "_fd",
    "_sc",
    "pb",
    "preview_theme_id",
  ];

  function toRelativeUrl(url) {
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function preserveEditorParams(targetUrl, currentUrl) {
    const current = new URL(currentUrl);
    const target = new URL(targetUrl, current.origin);

    editorParamNames.forEach((name) => {
      if (current.searchParams.has(name)) {
        target.searchParams.set(name, current.searchParams.get(name));
      }
    });

    return toRelativeUrl(target);
  }

  function removeParams(currentUrl, names, clearHash) {
    const url = new URL(currentUrl);
    names.forEach((name) => url.searchParams.delete(name));
    if (clearHash) url.hash = "";
    return toRelativeUrl(url);
  }

  function hasEditorParams(url) {
    return editorParamNames.some((name) => url.searchParams.has(name));
  }

  function isStoreDestination(url, currentUrl) {
    const app = global.umino_app || {};
    const storeHosts = [currentUrl.hostname, app.shop, app.domain].filter(Boolean);
    return storeHosts.includes(url.hostname);
  }

  function bindEditorLinkPreservation(document) {
    document.addEventListener("click", (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const clickTarget = event.target;
      const target = clickTarget && typeof clickTarget.closest === "function"
        ? clickTarget.closest("a[href]")
        : null;
      if (!target || target.target === "_blank" || target.hasAttribute("download")) return;

      const href = target.getAttribute("href");
      if (!href || href.startsWith("#") || /^(mailto:|tel:|javascript:)/i.test(href)) return;

      const current = new URL(global.location.href);
      if (!hasEditorParams(current)) return;

      const destination = new URL(target.href, current.origin);
      if (!isStoreDestination(destination, current)) return;

      const nextUrl = preserveEditorParams(target.href, current.href);
      if (nextUrl === toRelativeUrl(destination)) return;

      event.preventDefault();
      global.location.assign(nextUrl);
    }, true);
  }

  global.BlsUrlState = {
    preserveEditorParams,
    removeParams,
  };

  if (global.document && global.location) {
    bindEditorLinkPreservation(global.document);
  }
})(typeof window !== "undefined" ? window : globalThis);
